import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertIconComponent } from './alert-icon.component';
import { ButtonModule } from '@shared/button';
import {TranslateModule} from "@ngx-translate/core";



@NgModule({
	declarations: [
		AlertIconComponent
	],
	imports: [
		CommonModule,
		ButtonModule,
    TranslateModule
	],
	exports: [
		AlertIconComponent
	],
})
export class AlertIconModule { }
